import { $rtkApi } from 'shared/api/rtkApi';
import { ResponseData } from 'shared/types';
import {
  mapObjectStatisticsFromDto,
  mapObjectViewsAnalyticsFromDto,
  mapPriceSquareAnalyticsFromDto,
} from '../../lib/mapAnalytics';
import { LotStatusesStatistics } from '../types/objectAnalyticsSchema';
import {
  ObjectChartsData,
  ObjectChartsDataDto,
} from '../types/objectChartsSchema';
import {
  ObjectStatistics,
  ObjectStatisticsDto,
} from '../types/objectStatistics';
import {
  PriceSquareAnalytics,
  PriceSquareAnalyticsDto,
} from '../types/priceSquareAnalyticsSchema';

export const objectAnalyticsApi = $rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getLotStatusesStatistics: builder.query<
      LotStatusesStatistics,
      { objectId: number }
    >({
      query: ({ objectId }) => ({
        url: `/object-analytic/chess-status-statistic/${objectId}`,
        method: 'GET',
      }),
      transformResponse: (response: ResponseData<LotStatusesStatistics>) =>
        response.data,
    }),

    getPriceSquareStatistics: builder.query<
      PriceSquareAnalytics,
      { objectId: number }
    >({
      query: ({ objectId }) => ({
        url: `/object-analytic/price-square/${objectId}`,
        method: 'Get',
      }),
      transformResponse: (response: ResponseData<PriceSquareAnalyticsDto>) =>
        mapPriceSquareAnalyticsFromDto(response.data),
    }),

    getAreaChartsStatistics: builder.query<
      ObjectChartsData,
      { objectId: number; startDate: string; endDate: string }
    >({
      query: ({ objectId, startDate, endDate }) => ({
        url: `/object-analytic/area-charts`,
        method: 'Post',
        body: {
          building_id: objectId,
          start_date: startDate,
          end_date: endDate,
        },
      }),
      transformResponse: (response: ResponseData<ObjectChartsDataDto>) =>
        mapObjectViewsAnalyticsFromDto(response.data),
    }),

    getObjectStatistics: builder.query<
      ObjectStatistics,
      {
        objectId: number;
        startDate: string;
        endDate: string;
        prevStartDate: string;
        prevEndDate: string;
      }
    >({
      query: ({
        objectId,
        startDate,
        endDate,
        prevEndDate,
        prevStartDate,
      }) => ({
        url: `/object-analytic/object-statistic`,
        method: 'Post',
        body: {
          building_id: objectId,
          start_date: startDate,
          end_date: endDate,
          prev_start_date: prevStartDate,
          prev_end_date: prevEndDate,
        },
      }),
      transformResponse: (response: ResponseData<ObjectStatisticsDto>) =>
        mapObjectStatisticsFromDto(response.data),
    }),
  }),
});

export const {
  useGetLotStatusesStatisticsQuery,
  useGetPriceSquareStatisticsQuery,
  useGetAreaChartsStatisticsQuery,
  useGetObjectStatisticsQuery,
} = objectAnalyticsApi;
